module.exports = __webpack_public_path__ + "img/top_box_bg1.bc05e721.png";